// themes/atlantic/components.js
import React from 'react';

export const TypingIndicator = () => (
  <div className="flex space-x-2">
    <div className="w-3 h-3 rounded-full bg-sky-300 animate-synthwave-typing"></div>
    <div className="w-3 h-3 rounded-full bg-sky-300 animate-synthwave-typing" style={{animationDelay: '0.2s'}}></div>
    <div className="w-3 h-3 rounded-full bg-sky-300 animate-synthwave-typing" style={{animationDelay: '0.4s'}}></div>
  </div>
);

export const BackgroundEffects = () => (
  <div className="atlantic-background" style={{
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 0
  }}>
    {/* Enhanced Wave Pattern */}
    <div className="atlantic-wave animate-wave-pattern" style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundSize: '400% 400%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '0 0',
      background: 'linear-gradient(135deg, rgba(0, 255, 255, 0.2) 0%, rgba(0, 255, 255, 0) 70%)'
    }} />
    
    {/* Enhanced Floating Bubbles */}
    <div className="atlantic-bubbles" style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: '10px',
      padding: '10px'
    }}>
      {Array.from({ length: 30 }).map((_, i) => (
        <div 
          key={i}
          className="atlantic-bubble animate-bubble-float"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            width: `${Math.random() * 10 + 5}px`,
            height: `${Math.random() * 10 + 5}px`,
            backgroundColor: 'rgba(0, 255, 255, 0.3)',
            borderRadius: '50%',
            boxShadow: '0 0 10px rgba(0, 255, 255, 0.2)'
          }}
        />
      ))}
    </div>

    {/* Enhanced Depth Effects */}
    <div className="atlantic-depth" style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      <div className="atlantic-depth-layer animate-depth-effect" style={{
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        opacity: 0.8
      }} />
      <div className="atlantic-depth-layer animate-depth-effect delay-1000" style={{
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        opacity: 0.6
      }} />
    </div>
  </div>
);
